import { defineComponent as r, provide as a, toRef as l, computed as s, createBlock as i, openBlock as c, resolveDynamicComponent as d, withCtx as m, renderSlot as f } from "vue";
import { DefaultVariant as p, ListVariantKey as u } from "./TextList.constant.js";
const C = /* @__PURE__ */ r({
  name: "RevTextList",
  __name: "TextList",
  props: {
    variant: { default: p }
  },
  setup(n) {
    const e = n;
    a(
      u,
      l(() => e.variant)
    );
    const o = s(() => ({
      definition: "dl",
      ordered: "ol",
      unordered: "ul"
    })[e.variant]);
    return (t, v) => (c(), i(d(o.value), { class: "flex flex-col" }, {
      default: m(() => [
        f(t.$slots, "default")
      ]),
      _: 3
    }));
  }
});
export {
  C as default
};
